import * as React from 'react';

const TABLET_MEDIA =
  '(min-width: 768px) and ((pointer: coarse), (hover: none))';
const COARSE_POINTER_MEDIA = '(pointer: coarse)';
const NO_HOVER_MEDIA = '(hover: none)';

function detectTablet(): boolean {
  if (typeof window === 'undefined') return false;
  if (window.matchMedia(TABLET_MEDIA).matches) return true;
  if (
    window.innerWidth >= 768 &&
    (window.matchMedia(COARSE_POINTER_MEDIA).matches ||
      window.matchMedia(NO_HOVER_MEDIA).matches)
  ) {
    return true;
  }
  // iPadOS desktop mode / Safari can report fine pointer — still a touch tablet.
  return window.innerWidth >= 768 && navigator.maxTouchPoints > 0;
}

export function useIsTablet() {
  const [isTablet, setIsTablet] = React.useState(detectTablet);

  React.useEffect(() => {
    const mql = window.matchMedia(TABLET_MEDIA);
    const onChange = () => setIsTablet(detectTablet());
    mql.addEventListener('change', onChange);
    setIsTablet(detectTablet());
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return isTablet;
}
